import React from "react";
import * as DIAG from "storm-react-diagrams";
import PreviewNodeView from "./PreviewNodeView";

export default class PreviewNodeFactory extends DIAG.NodeWidgetFactory {
    /**
	 * Node factory for diagram preview
	 * @module PreviewNodeFactory
     */
	constructor() {
		super("default");
	}

    /**
	 * Generator
     * @param diagramEngine DiagramEngine instance for current diagram
     * @param node Node model
     * @returns {Object} React element
     */
	generateReactWidget(diagramEngine, node) {
		return React.createElement(PreviewNodeView, {
			node: node,
			diagramEngine: diagramEngine
		});
	}
}
